/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal, Ivan Ryabov, Leonid Khramov
 */
import React, { Component } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'

import { webApi } from '../../lib/WebApi'
import Uploader from '../../lib/Uploader'
import * as act from './actions'
import EditGameTeam from './components/EditGameTeam.js'
import EditGameInfo from './components/EditGameInfo.js'
import VideoProgress from './components/VideoProgress.js'
import Waiting from './components/Waiting.js'
import Modal from '../../components/Modal.js'
import Processing from './components/Processing.js'
import ErrorSection from './components/ErrorSection.js'
import Footer from './components/Footer.js'
import MissingOpponent from './components/MissingOpponent.js'
import Sensors from './components/Sensors.js'
import DefaultError from './components/DefaultError.js'
import ErrorDialog from './components/ErrorDialog.js'
import { ModalPage } from '../../modules/Navigation/ModalPage'

import { validateGame } from './game_validation.js'

import './UploadGame.css'


const validVideoExtensions = ['mp4', 'mkv', 'mts', 'mov', 'm2ts', 'mpg', 'mpeg', 'avi']

class UploadGameComponent extends Component {

    // Lifecycle Methods

    constructor() {
        super()
        this.logs = `Log started ${new Date()}`
        this._checksPassed = false
        this._videoUploadsCompleted = false
        this._processingGame = false

        this.homeScoreChanged = this.homeScoreChanged.bind(this)
        this.homeColorChanged = this.homeColorChanged.bind(this)
        this.awayTeamChanged = this.awayTeamChanged.bind(this)
        this.awayScoreChanged = this.awayScoreChanged.bind(this)
        this.awayColorChanged = this.awayColorChanged.bind(this)
        this.gameDateChanged = this.gameDateChanged.bind(this)
        this.gameTimeChanged = this.gameTimeChanged.bind(this)
        this.halfLengthChanged = this.halfLengthChanged.bind(this)
        this.piIdChanged = this.piIdChanged.bind(this)
        this.cameraIdChanged = this.cameraIdChanged.bind(this)
        this.suggestionPressed = this.suggestionPressed.bind(this)
        this.filesChanged = this.filesChanged.bind(this)
        this.uploadProgressChanged = this.uploadProgressChanged.bind(this)
        this.nextPressed = this.nextPressed.bind(this)
        this.backPressed = this.backPressed.bind(this)
        this.cancelUpload = this.cancelUpload.bind(this)


        this.processUpdateGame = this.processUpdateGame.bind(this)
        this.processStart = this.processStart.bind(this)

        this.loadVideoFiles = this.loadVideoFiles.bind(this)

        this.missingOpponentPrimaryPressed = this.missingOpponentPrimaryPressed.bind(this)
        this.missingOpponentGhostPressed = this.missingOpponentGhostPressed.bind(this)
        this.sensorsErrPrimaryPressed = this.sensorsErrPrimaryPressed.bind(this)
        this.sensorsErrGhostPressed = this.sensorsErrGhostPressed.bind(this)
        this.defaultErrPrimaryPressed = this.defaultErrPrimaryPressed.bind(this)
        this.defaultErrGhostPressed = this.defaultErrGhostPressed.bind(this)
        this.caseErrorOK = this.caseErrorOK.bind(this)
        this.timeErrorOK = this.timeErrorOK.bind(this)
        this.uploadsErrorContinue = this.uploadsErrorContinue.bind(this)
        this.uploadsErrorFix = this.uploadsErrorFix.bind(this)
        this.fileErrorOK = this.fileErrorOK.bind(this)
        this.scoreErrorFix = this.scoreErrorFix.bind(this)
        this.scoreErrorContinue = this.scoreErrorContinue.bind(this)
        this.colorsErrorFix = this.colorsErrorFix.bind(this)
        this.colorsErrorContinue = this.colorsErrorContinue.bind(this)
        this.deleteFileConfirm = this.deleteFileConfirm.bind(this)
        this.deleteFileReject = this.deleteFileReject.bind(this)
        this.cameraSyncErrorFix = this.cameraSyncErrorFix.bind(this)

        this.cancelNewGame = this.cancelNewGame.bind(this)
        this.hideCancelNewGame = this.hideCancelNewGame.bind(this)
        this.onCancelNewGame = this.onCancelNewGame.bind(this)

        this.onClose = this.onClose.bind(this)
        this.onBack = this.onBack.bind(this)


        this.uploader = new Uploader()

        this.state = {
            teamSuggestions: [],
            uploads: {},
            ignoreErrors: [],
            fileErrorTitle: '',
            fileErrorContent: '',

            showMissingOpponentErr: false,
            showSensorsErr: false,
            showUploadsErr: false,
            showCaseErr: false,
            showTimeErr: false,
            showDefaultErr: false,
            showFileErr: false,
            showNoTeamErr: false,
            showScoreErr: false,
            showColorsErr: false,
            showCameraSyncErr: false,

            showDeleteFileConfirm: false,
            deleteFile: null,

            showCancelNewGameModal: false,
        }

        var self = this
        webApi.logResponses = (msg) => {
            self.log(msg)
        }
    }

    get checksPassed() {
        return this._checksPassed
    }

    set checksPassed(val) {
        if (val !== this._checksPassed) {
            this._checksPassed = val
            this.startGameProcessingIfReady()
        }
    }

    get videoUploadsCompleted() {
        return this._videoUploadsCompleted
    }

    set videoUploadsCompleted(val) {
        if (val !== this._videoUploadsCompleted) {
            this._videoUploadsCompleted = val
            this.startGameProcessingIfReady()
        }
    }

    componentWillReceiveProps(nextProps) {
        if(nextProps.showErrors && !this.props.showErrors) {
            const gameFolder = this.props.game && this.props.game.home_team
                ? this.props.game.home_team.s3_sources.split('/').pop()
                : null

            webApi.logError(this.logs, gameFolder)
            this.logs = `Log re-started ${new Date()}`
        }
    }

    componentDidMount() {
        this.uploader.setup()

        this.showEditGame()
        this.loadGameData()
    }

    log(msg) {
        this.logs += `\n${msg}`
    }






    // Logic

    loadGameData() {
        webApi.getGame(this.props.gameId)
            .then(game => {
                this.props.setGame(game)
            })
            .then(this.loadVideoFiles)
            .then(() => {
                this.showEditGame()
            })
            .catch(err => {
                console.error(err)
                this.log(err)
            })
    }

    loadVideoFiles() {
        var wthis = this
        return new Promise((resolve, reject) => {
            var gameFolder = wthis.props.game.home_team.s3_sources.split('/').pop()
            webApi.listVideos(gameFolder)
                .then(json => {
                    var allVideos = wthis.state.uploads
                    for (var i in json.video) {
                        var vid = json.video[i]
                        wthis.log(`restored video file ${vid.name}`)
                        allVideos[vid.Key] = {
                            key: vid.Key,
                            file: vid.name,
                            uploaded: 1,
                            success: 1,
                            location: null,
                            error: null
                        }
                    }
                    wthis.setState({ uploads: allVideos })
                    if (Object.keys(allVideos).length > 0) {
                        wthis.videoUploadsCompleted = true
                    }
                    resolve(true)
                })
                .catch(err => {
                    this.log(err)
                    reject(err)
                })

        })
    }

    nextPressed(e) {
        if (e) {
            e.preventDefault()
        }

        if (this.props.camera !== 'regular') {
            this.onClose()
        }

        var that = this
        this.showWaiting()
        var team = this.props.team
        var game = this.props.game
        var uploads = this.state.uploads
        var ignoreErrors = this.state.ignoreErrors

        validateGame(team, game, uploads, ignoreErrors)
            .then(() => {
                that.checksPassed = true
            })
            .then(() => {
                if (game.camera_type === 'trace') {
                    that.videoUploadsCompleted = true
                    that.startGameProcessingIfReady()
                }
            })
            .catch(err => {
                this.log(`preprocess check error ${err}`)
                switch(err) {
                case 'missing_opponent':
                    this.setState({
                        showMissingOpponentErr: true
                    })
                    break
                case 'missing_case_id':
                    this.setState({
                        showCaseErr: true
                    })
                    this.showEditGame()
                    break
                case 'invalid_game_time':
                    this.setState({
                        showTimeErr: true
                    })
                    this.showEditGame()
                    break
                case 'uploads':
                    this.setState({
                        showSensorsErr: true
                    })
                    break
                case 'sensors':
                    this.setState({
                        showSensorsErr: true
                    })
                    break
                case 'coach_notes':
                    alert('no coach notes')
                    this.showEditGame()
                    break
                case 'camera_sync':
                    this.setState({
                        showCameraSyncErr: true
                    })
                    this.showEditGame()
                    break
                case 'score_warning':
                    this.setState({
                        showScoreErr: true
                    })
                    this.showEditGame()
                    break
                case 'colors_warning':
                    this.setState({
                        showColorsErr: true
                    })
                    this.showEditGame()
                    break
                default:
                    this.setState({
                        showDefaultErr: true
                    })
                }
            })
    }

    backPressed() {
        this.checksPassed = false
        this.showEditGame()
    }



    isNextEnabled() {
        if (this.props.camera === 'trace') {
            return true
        }

        // Next button is enabled when video files are added to the game
        var keys = Object.keys(this.state.uploads)
        if (keys.length === 0) {
            return false
        }

        return true
    }

    updateGame() {
        var that = this
        setTimeout(() => {
            var game = that.props.game
            that.log(`updating game ${game}`)
            var uploadCount = Object.keys(that.state.uploads).length
            webApi.updateGame(game, uploadCount)
        }, 250)
    }

    onClose() {
        this.props.history.replace(`/${this.props.match.params.team}`)
    }

    onBack() {
        this.props.history.go(-1)
    }













    // Video Uploads Completed start processing

    startGameProcessingIfReady() {
        if (this.checksPassed && this.videoUploadsCompleted && !this._processingGame) {
            this._processingGame = true
            this.processGame()
        } else {
            console.log('not ready to start processing yet', this.checksPassed, this.videoUploadsCompleted, this._processingGame)
        }
    }

    processGame() {
        webApi.postSlack(`Trying to start processing pi: ${this.props.game.pi_id}, camera:${this.props.game.camera_pi_id}`, null, this.props.threadTS)
        this.showProcessing()
        this.processUpdateGame()
            .then(this.processStart)
            .then(() => {
                this.processStatus()
            })
            .catch(err => {
                webApi.postSlack(`Process game error ${err}`, null, this.props.threadTS)
                console.log('process game error', err)
            })
    }

    processUpdateGame() {
        return new Promise((resolve, reject) => {
            var files = Object.keys(this.state.uploads).length
            webApi.updateGame(this.props.game, files)
                .then((gameResult) => {
                    resolve(true)
                })
                .catch((err) => {
                    console.log('failed updating game', err)
                    webApi.postSlack(`Process update game error ${err}`, null, this.props.threadTS)
                    reject(err)
                })
        })
    }

    processStart() {
        return
    }

    processStatus() {
        var wthis = this
        const cb = () => {
            wthis.processStatus()
        }

        webApi.getGame(this.props.game.game_id)
            .then(game => {
                console.log('processStatus game', game.status)
                let url = ''
                if (this.props.camera === 'trace') {
                    url = `/#/${this.props.game.home_team.name}`
                    window.location.replace(url)
                }
                else if (game.status === 'process_error') {
                    this.showErrors()
                }
                else if (game.status === 'processing') {
                    url = `/#/${this.props.game.home_team.name}`
                    window.location.replace(url)
                }
                else {
                    setTimeout(cb, 60000 * 1)
                }
            })
            .catch(err => {
                console.log('processStatus err', err)
                setTimeout(cb, 60000 * 1)
            })
    }

    gameInfoStatus() {
        var wthis = this
        const cb = () => {
            wthis.gameInfoStatus()
        }

        webApi.checkGameInfoFile(this.props.game.home_team.name, this.props.game.game_id)
            .then(gameInfo => {
                console.log('gameInfoStatus gameInfo', gameInfo)
                if (gameInfo) {
                    var url = `/#/${this.props.game.home_team.name}/games/${this.props.game.home_team.name}-${this.props.game.game_id}/playlists/coach-notes/1`
                    window.location.replace(url)
                } else {
                    setTimeout(cb, 60000 * 5)
                }
            })
            .catch(err => {
                console.log('gameInfoStatus err', err)
                setTimeout(cb, 60000 * 5)
            })
    }









    // Form Handlers

    homeScoreChanged(value, e) {
        var ht = this.props.game.home_team
        ht.score = parseInt(value, 10)
        this.log(`set game home score ${value}`)
        this.props.updateGameWith('home_team', ht)
        this.updateGame()

        webApi.postSlack(`Set home score to ${value}`, null, this.props.threadTS)
    }
    homeColorChanged(e) {
        var value = e.currentTarget.value
        var ht = this.props.game.home_team
        ht.jersey_color = value
        this.log(`set game home color ${value}`)
        this.props.updateGameWith('home_team', ht)
        this.updateGame()

        webApi.postSlack(`Set home color to ${value}`, null, this.props.threadTS)
    }
    awayTeamChanged(value, e) {
        var awayTeam = {
            team_id: -1,
            title: value,
            name: '',
            players: [],
            s3_sources: '',
            abbr: '',
            score: this.props.game.away_team.score,
            jersey_color: this.props.game.away_team.jersey_color
        }
        for (var i in this.state.teamSuggestions) {
            var tm = this.state.teamSuggestions[i]
            if (tm.title === value) {
                awayTeam = tm
                webApi.postSlack(`Set awayTeam to ${value}`, null, this.props.threadTS)
                console.log('matched suggestion')
                break
            }
        }
        this.props.updateGameWith('away_team', awayTeam)

        // auto suggestions should be empty unless input is more than 2 characters
        if (value.length <= 2) {
            // value is to short abort, no suggestions
            this.setState({ teamSuggestions: [] })
            return
        }

        webApi.autoCompleteTeam(value)
            .then((teams) => {
                this.setState({ teamSuggestions: teams })
            })
            .catch((err) => {
                console.log(err)
            })
    }
    awayScoreChanged(value, e) {
        var at = this.props.game.away_team
        at.score = parseInt(value, 10)
        this.log(`set game away score ${value}`)
        this.props.updateGameWith('away_team', at)
        this.updateGame()

        webApi.postSlack(`Set away score to ${value}`, null, this.props.threadTS)
    }
    awayColorChanged(e) {
        var value = e.currentTarget.value
        var at = this.props.game.away_team
        at.jersey_color = value
        this.log(`set game away color ${value}`)
        this.props.updateGameWith('away_team', at)
        this.updateGame()

        webApi.postSlack(`Set away color to ${value}`, null, this.props.threadTS)
    }
    gameDateChanged(e) {
        var value = e.currentTarget.value
        this.log(`set game date ${value}`)
        this.props.updateGameWith('date', value)
        this.updateGame()

        webApi.postSlack(`Set game date to ${value}`, null, this.props.threadTS)
    }
    gameTimeChanged(e) {
        var value = e.currentTarget.value
        this.log(`set game time ${value}`)
        this.props.updateGameWith('approx_start_time', value)
        this.updateGame()

        webApi.postSlack(`Set game time to ${value}`, null, this.props.threadTS)
    }
    halfLengthChanged(e) {
        var value = e.currentTarget.value
        this.log(`set game half length ${value}`)
        this.props.updateGameWith('approx_half_duration', value)
        this.updateGame()

        webApi.postSlack(`Set half length to ${value}`, null, this.props.threadTS)
    }
    piIdChanged(value, e) {
        this.log(`set pi id ${value}`)
        this.props.updateGameWith('pi_id', value)
        this.updateGame()
    }
    cameraIdChanged(value, e) {
        this.log(`set camera id ${value}`)
        this.props.updateGameWith('camera_pi_id', value)
        this.props.updateGameWith('trace_case_id', value)
        this.updateGame()
    }
    suggestionPressed(e) {
        e.preventDefault()
        for (var i in this.state.teamSuggestions) {
            var team = this.state.teamSuggestions[i]
            if (e.currentTarget.innerText === team.title) {
                this.props.updateGameWith('away_team', team)
                this.log(`set game away team ${team}`)
                this.updateGame()
                this.setState({ teamSuggestions: [] })
                break
            }
        }
    }
    filesChanged(e) {
        const newUploads = []
        var duplicateFiles = []
        var invalidFiles = []

        for (let file of e.target.files) {
            const dateStr = moment().format('YYYYMD_Hm')
            const fileExt = file.name.split('.').pop()
            let fileName = file.name.replace(`.${fileExt}`, '').toLowerCase()
            fileName = fileName.replace(/\W+/g, '_')
            fileName = `${fileName}_${dateStr}.${fileExt}`
            webApi.postSlack(`Added file ${fileName}`, null, this.props.threadTS)

            if (validVideoExtensions.indexOf(fileExt.toLowerCase()) >= 0) {
                this.log(`adding file to upload ${fileName}`)
                const to = `data/${this.props.team.name}-${this.props.game.game_id}/video/${fileName}`
                var upKeys = Object.keys(this.state.uploads)
                var dupe = false
                var failedDupe = false
                var dupeKey = false
                for (var i in upKeys) {
                    var key = upKeys[i]
                    console.log('checking for dupe in', key)
                    var cup = this.state.uploads[key]

                    console.log(file.name, cup.file)
                    if (cup != null && file.name === cup.file) {
                        dupe = true
                        if (cup.error != null) {
                            failedDupe = true
                            dupeKey = key
                        }
                        break
                    }
                }
                if (dupe === false || failedDupe === true) {
                    const upload = this.uploader.upload(file, to, this.uploadProgressChanged)
                    if (failedDupe) {
                        upload.key_to_remove = dupeKey
                    }
                    newUploads.push(upload)
                } else {
                    duplicateFiles.push(file.name)
                }
                // check for duplicate files
                // duplicateFiles.push(file.name);
            } else {
                invalidFiles.push(file.name)
            }
        }

        if (newUploads.length > 0) {
            const allUploads = {...this.state.uploads}
            console.log(allUploads)
            console.log('---')
            for (let upload of newUploads) {
                allUploads[upload.key] = upload
                if (upload.key_to_remove) {
                    delete allUploads[upload.key_to_remove]
                }
            }
            console.log(allUploads)
            this.setState({ uploads: allUploads })
            this.videoUploadsCompleted = false
        }

        let title, dupeList, content, invalidList

        if (duplicateFiles.length > 0 && invalidFiles.length > 0) {
            title = 'Files Not Added'
            dupeList = duplicateFiles.map(f => (<li key={f}>{f}</li>))
            invalidList = invalidFiles.map(f => (<li key={f}>{f}</li>))
            content = (<div>
                <p>The following files were not added because they are duplicates of files already uploaded or currently uploading:</p>
                <ul>{ dupeList }</ul>
                <p>The following files were not added because they are not a supported video file type:</p>
                <ul>{ invalidList }</ul>
            </div>)
            this.setState({ showFileErr: true, fileErrorTitle: title, fileErrorContent: content})
        } else if (duplicateFiles.length > 0) {
            title = 'Files Not Added'
            dupeList = duplicateFiles.map(f => (<li key={f}>{f}</li>)) 
            content = (<div>
                <p>The following files were not added because they are duplicates of files already uploaded or currently uploading:</p>
                <ul>{ dupeList }</ul>
            </div>)
            this.setState({ showFileErr: true, fileErrorTitle: title, fileErrorContent: content})
        } else if (invalidFiles.length > 0) {
            title = 'Files Not Added'
            invalidList = invalidFiles.map(f => (<li key={f}>{f}</li>)) 
            content = (<div>
                <p>The following files were not added because they are not a supported video file type:</p>
                <ul>{ invalidList }</ul>
            </div>)
            this.setState({ showFileErr: true, fileErrorTitle: title, fileErrorContent: content})
        }
    }
    uploadProgressChanged(prog) {
        let allUploads = this.state.uploads
        if (allUploads[prog.key].uploaded !== prog.uploaded || prog.success !== allUploads[prog.key].success) {
            allUploads[prog.key] = Object.assign({}, allUploads[prog.key], prog)
            let completed = true
            for (var k in allUploads) {
                completed = (allUploads[k].success === true || allUploads[k].success === 1) && completed
            }
            console.log('upload progress', completed)
            console.log(allUploads)
            this.videoUploadsCompleted = completed
            this.setState({ uploads: allUploads })
        }
    }
    cancelUpload(upload) {
        this.setState({ showDeleteFileConfirm: true, deleteFile: upload.key })
        return

        
    }

    cancelNewGame() {
        this.setState({
            showCancelNewGameModal: true
        })
    }

    hideCancelNewGame() {
        this.setState({
            showCancelNewGameModal: false
        })
    }

    onCancelNewGame() {
        if (this.props.game && this.props.game.game_id) {
            webApi._post(`/webapp/games/${this.props.game.game_id}/delete`)
                .then(data => {
                    window.history.go(-2)
                })
                .catch(err => {
                    window.history.go(-2)
                })
        } else {
            window.history.back()
        }
    }


    //// Navigation

    showEditGame() {
        this.props.show({
            showEditGameTeams: true,
            showVideosProgress: this.props.camera === 'regular',
            showAddVideos: this.props.camera === 'regular',
            showEditGameInfo: this.props.camera === 'regular',
            showRoster: false,
            showWaiting: false,
            showProcessing: false,
            showErrors: false
        })
    }

    showWaiting() {
        this.props.show({
            showEditGameTeams: false,
            showVideosProgress: this.props.camera !== 'trace',
            showAddVideos: false,
            showEditGameInfo: false,
            showRoster: false,
            showWaiting: true,
            showProcessing: false,
            showErrors: false
        })
    }

    showProcessing() {
        this.props.show({
            showEditGameTeams: false,
            showVideosProgress: false,
            showAddVideos: false,
            showEditGameInfo: false,
            showRoster: false,
            showWaiting: false,
            showProcessing: true,
            showErrors: false
        })
    }

    showErrors() {
        this.props.show({
            showEditGameTeams: false,
            showVideosProgress: false,
            showAddVideos: false,
            showEditGameInfo: false,
            showRoster: false,
            showWaiting: false,
            showProcessing: false,
            showErrors: true
        })
    }


    /**** Error modals handlers ****/

    missingOpponentPrimaryPressed() {
        this.setState({showMissingOpponentErr: false})

        this.showEditGame()
    }
    missingOpponentGhostPressed() {
        const ignores = [...this.state.ignoreErrors, 'missing_opponent']
        this.setState({ignoreErrors: ignores, showMissingOpponentErr: false}, this.nextPressed)
    }

    sensorsErrPrimaryPressed() {
        this.setState({showSensorsErr: false})
        this.showEditGame()
    }
    sensorsErrGhostPressed() {
        const ignores = [...this.state.ignoreErrors, 'sensors', 'uploads']
        this.setState({ignoreErrors: ignores, showSensorsErr: false})

        var that = this
        setTimeout(() => { that.nextPressed() }, 250)
    }

    defaultErrPrimaryPressed() {
        this.setState({showSensorsErr: false})
    }
    defaultErrGhostPressed() {
        
    }
    uploadsErrorFix() {
        this.setState({showUploadsErr: false})
    }
    uploadsErrorContinue() {
        const ignores = [...this.state.ignoreErrors, 'uploads', 'sensors']
        this.setState({ignoreErrors: ignores, showUploadsErr: false})
        var that = this
        setTimeout(() => { that.nextPressed() }, 250)
    }
    caseErrorOK() {
        const ignores = [...this.state.ignoreErrors, 'missing_case_id']
        this.setState({ignoreErrors: ignores, showCaseErr: false})

        // Set focus on case element
        var element = document.getElementById('input_case_id')
        element.focus()
    }
    timeErrorOK() {
        const ignores = [...this.state.ignoreErrors, 'invalid_game_time']
        this.setState({ignoreErrors: ignores, showTimeErr: false})

        // Set focus on date element
        var element = document.getElementById('input_date')
        element.focus()
    }
    fileErrorOK() {
        this.setState({showFileErr: false})
    }
    scoreErrorFix() {
        this.setState({ showScoreErr: false })
    }
    scoreErrorContinue() {
        const ignores = [...this.state.ignoreErrors, 'score_warning']
        this.setState({ignoreErrors: ignores, showScoreErr: false})

        var that = this
        setTimeout(() => { that.nextPressed() }, 250)
    }
    colorsErrorFix() {
        this.setState({ showColorsErr: false })
    }
    colorsErrorContinue() {
        const ignores = [...this.state.ignoreErrors, 'colors_warning']
        this.setState({ignoreErrors: ignores, showColorsErr: false})

        var that = this
        setTimeout(() => { that.nextPressed() }, 250)
    }
    deleteFileConfirm() {
        var fileKey = this.state.deleteFile

        var upload = this.state.uploads[fileKey]
        var uploads = this.state.uploads
        if (upload) {
            delete uploads[upload.key]
            
        }
        this.setState({ 
            uploads: uploads, 
            showDeleteFileConfirm: false,
            deleteFile: null
        })
        var gameFolder = this.props.game.home_team.s3_sources.split('/').pop()
        var fn = fileKey.replace(`data/${gameFolder}/video/`, '')
        webApi.ignoreVideoFile(gameFolder, fn).catch(err => console.log(err))
    }
    deleteFileReject() {
        this.setState({ showDeleteFileConfirm: false, deleteFile: null })
    }
    cameraSyncErrorFix() {
        console.log('cameraSyncErrorFix')
        this.setState({ showCameraSyncErr: false })
    }


    /**** UI Helpers ****/

    safeVal(val, def = '') {
        return val != null ? val : def
    }

    dateVal(val) {
        let sval = this.safeVal(val, '1970-01-01 00:00:00')
        let parts = sval.split(' ')
        return parts[0]
    }

    timeVal(val) {
        let sval = this.safeVal(val, '1970-01-01 00:00:00')
        var parts = sval.split(' ')
        return parts[1]
    }

    dateFromString(val, mo = 1) {
        var str = this.safeVal(val, '1970-01-01 00:00:00')
        var parts = str.split(' ')
        var date = new Date(0)
        if (parts.length === 2) {
            var dateParts = parts[0].split('-')
            var timeParts = parts[1].split(':')
            if (dateParts.length === 3 && timeParts.length >= 2) {
                var y = parseInt(dateParts[0], 10)
                var m = parseInt(dateParts[1], 10) - mo
                var d = parseInt(dateParts[2], 10)
                var hh = parseInt(timeParts[0], 10)
                var mm = parseInt(timeParts[1], 10)
                date = new Date(y, m, d, hh, mm)
            }
        }
        return date
    }

    boolToStyles(val) {
        if (val === true) {
            return {}
        } else {
            return { display: 'none' }
        }
    }

    offlineWarning() {
        if (this.props.online === false) {
            return <p className="off-line-warning">NO INTERNET CONNECTION</p>
        } 
        return ''
    }

    render() {
        let styles = {}
        if (this.props.show === false) {
            styles['display'] = 'none'
        }

        var camera = false
        if (this.props.camera === 'trace') {
            camera = true
        }
        console.log('UploadGame.camera', this.props.game)
        
        // Error Messages
        var missingCaseIdContent = (<p>Please fill the &quot;Case Id&quot; with the value on your trace case</p>)
        var invalidDateContent = (<p>Please ensure that date and time are correct for your game.</p>)
        var noTeamContent = (<p>The url of this page is missing your team id.  Please go back to your game listing and click on create game.</p>)
        var scoreContent = (<p>The score entered for this game is 0-0. Is this the correct score?</p>)
        var colorContent = (<p>The colors entered are both the default. Are these colors correct??</p>)
        var cameraSyncContent = (<p>Unable to find camera sync data for the data and time provided. Make sure the game date and time are correct and try again.</p>)
        var upload = this.state.uploads[this.state.deleteFile]
        var fileName = ''
        if (upload) {
            fileName = upload.file
        }
        var deleteFileContent = (<p>Are you sure you want to cancel/remove upload for file {fileName}</p>)

        var title = 'Game Settings'

        console.log('game', this.props.game)

        return (
            <ModalPage title={title} showBack={true} onClosePressed={this.onClose}>
                <div className="UploadGame modal-container">

                    {this.offlineWarning()}


                    <div className="trace-container game-page-content">
                    
                        <EditGameTeam
                            show={this.props.showEditGameTeams}
                            homeTeamId={this.safeVal(this.props.game.home_team.team_id)}
                            awayTeamId={this.safeVal(this.props.game.away_team.team_id)}
                            homeScore={this.safeVal(this.props.game.home_team.score)}
                            homeScoreChanged={this.homeScoreChanged}
                            awayScore={this.safeVal(this.props.game.away_team.score)}
                            awayScoreChanged={this.awayScoreChanged}
                            homeColor={this.safeVal(this.props.game.home_team.jersey_color)}
                            homeColorChanged={this.homeColorChanged}
                            awayColor={this.safeVal(this.props.game.away_team.jersey_color)}
                            awayColorChanged={this.awayColorChanged}
                            homeTeamTitle={this.safeVal(this.props.game.home_team.title)}
                            awayTeamTitle={this.safeVal(this.props.game.away_team.title)}
                            awayTeamTitleChanged={this.awayTeamChanged}
                            suggestions={this.state.teamSuggestions}
                            suggestionsPressed={this.suggestionPressed}
                        />
                        {!this.props.showEditGameTeams && this.props.showVideosProgress &&
                        (<div className="extra-space"></div>)}
                        <VideoProgress
                            show={this.props.showVideosProgress}
                            uploads={this.state.uploads}
                            cancelUpload={this.cancelUpload}
                        />

                        <EditGameInfo
                            show={this.props.showEditGameInfo}
                            gameDate={this.safeVal(this.props.game.date)}
                            gameTime={this.safeVal(this.props.game.approx_start_time)}
                            gameDateChanged={this.gameDateChanged}
                            gameTimeChanged={this.gameTimeChanged}
                            halfLength={this.safeVal(this.props.game.approx_half_duration)}
                            halfLengthChanged={this.halfLengthChanged}
                            pi
                            piId={this.safeVal(this.props.game.pi_id)}
                            piIdChanged={this.piIdChanged}
                            camera={camera}
                            cameraId={this.props.game.camera_pi_id}
                            cameraIdChanged={this.cameraIdChanged}
                        />

                        <Waiting
                            show={this.props.showWaiting}
                            backPressed={this.backPressed}
                        />

                        <Processing
                            show={this.props.showProcessing}
                        />

                        <ErrorSection
                            show={this.props.showErrors}
                            log={this.logs}
                            game={this.props.game}
                            onUnderstand={(e) => {
                                e.preventDefault()
                                window.location = `/#/${this.props.team.name}`
                            }}
                        />
                        <Footer
                            show
                            showLoading={false}
                            nextDisabled={!this.isNextEnabled()}
                            showWaiting={this.props.showWaiting}
                            showProcessing={this.props.showProcessing}
                            showErrors={this.props.showErrors}
                            backPressed={this.backPressed}
                            nextPressed={this.nextPressed}
                        />
                    </div>
                    

                    <MissingOpponent
                        show={this.state.showMissingOpponentErr}
                        primaryBtnPressed={this.missingOpponentPrimaryPressed}
                        ghostBtnPressed={this.missingOpponentGhostPressed}
                    />

                    <Sensors
                        show={this.state.showSensorsErr}
                        primaryBtnPressed={this.sensorsErrPrimaryPressed}
                        ghostBtnPressed={this.sensorsErrGhostPressed}
                    />
                    <Sensors
                        show={this.state.showUploadsErr}
                        primaryBtnPressed={this.uploadsErrorFix}
                        ghostBtnPressed={this.uploadsErrorContinue}
                    />

                    <DefaultError
                        show={this.state.showDefaultErr}
                        primaryBtnPressed={this.defaultErrPrimaryPressed}
                        ghostBtnPressed={this.defaultErrGhostPressed}
                    />

                    <ErrorDialog
                        show={this.state.showNoTeamErr}
                        title="Missing Team"
                        content={noTeamContent}
                    />
                    <ErrorDialog
                        show={this.state.showCaseErr}
                        title="Missing Case Id"
                        content={missingCaseIdContent}
                        primaryTitle="I'll Fix It"
                        primaryBtnPressed={this.caseErrorOK}
                    />
                    <ErrorDialog
                        show={this.state.showTimeErr}
                        title="Invalid Date"
                        content={invalidDateContent}
                        primaryTitle="I'll Fix It"
                        primaryBtnPressed={this.timeErrorOK}
                    />
                    <ErrorDialog
                        show={this.state.showFileErr}
                        title={this.state.fileErrorTitle}
                        content={this.state.fileErrorContent}
                        primaryTitle="OK"
                        primaryBtnPressed={this.fileErrorOK}
                    />
                    <ErrorDialog
                        show={this.state.showScoreErr}
                        title="Is Score Correct?"
                        content={scoreContent}
                        primaryTitle="No, I'll Fix It"
                        primaryBtnPressed={this.scoreErrorFix}
                        ghostTitle="Yes, Continue"
                        ghostBtnPressed={this.scoreErrorContinue}
                    />

                    <ErrorDialog
                        show={this.state.showColorsErr}
                        title="Forgot Team Colors?"
                        content={colorContent}
                        primaryTitle="No, I'll Fix It"
                        primaryBtnPressed={this.colorsErrorFix}
                        ghostTitle="Yes, Continue"
                        ghostBtnPressed={this.colorsErrorContinue}
                    />

                    <ErrorDialog
                        show={this.state.showDeleteFileConfirm}
                        title="Remove Video?"
                        content={deleteFileContent}
                        primaryTitle="Yes, remove it"
                        primaryBtnPressed={this.deleteFileConfirm}
                        ghostTitle="NO, keep it"
                        ghostBtnPressed={this.deleteFileReject}
                    />

                    <ErrorDialog
                        show={this.state.showCameraSyncErr}
                        title="Missing Camera Sync"
                        content={cameraSyncContent}
                        primaryTitle="OK"
                        primaryBtnPressed={this.cameraSyncErrorFix}
                    />
                        
                    <Modal 
                        title="Cancel New Game" 
                        open={this.state.showCancelNewGameModal} 
                        whoops={true}
                        hideCloseBtn={true}
                        className="cancel-game-modal">
                        <p>Are you sure you want to cancel creating a new game? All the information you&apos;ve entered and all of the video files you have uploaded will be lost.</p>
                        <div className="buttons">
                            <button className="trace-input secondary whoops" onClick={this.hideCancelNewGame}>No</button>
                            <button className="trace-input whoops" onClick={this.onCancelNewGame}>Yes, Cancel It.</button>
                        </div>
                    </Modal>
                </div>
            </ModalPage>
        )
    }

}

const mapStateToProps = (state, props) => {
    var online = true //state.upload.upload.online;
    var loggedIn = state.isLoggedIn
    var game = state.upload.game
    if (game.camera_pi_id === undefined) {
        game.camera_pi_id = game.trace_case_id
    }
    if (game.camera_type === undefined) {
        game.camera_type = props.match.params.camera
    }
    game.tournament_id = 2
    var team = state.team.value ? state.team.value : { title: ' ' }
    var teamId = state.team.value ? state.team.value.team_id : -1
    var gameId = parseInt(props.match.params.game_id, 10)
    var threadTS = state.upload.thread_ts

    let camera = state.upload.game.camera_type
    if (window.location.href.match(/uploader/gi)) {
        camera = 'regular'
    }

    return {
        showEditGameTeams: state.upload.showEditGameTeams,
        showVideosProgress: state.upload.showVideosProgress,
        showAddVideos: state.upload.showAddVideos,
        showEditGameInfo: state.upload.showEditGameInfo,
        showRoster: state.upload.showRoster,
        showWaiting: state.upload.showWaiting,
        showProcessing: state.upload.showProcessing,
        showErrors: state.upload.showErrors,
        camera: camera,
        online,
        loggedIn,
        game,
        team,
        gameId,
        teamId,
        threadTS
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setLoggedIn: (loggedIn) => {
            dispatch(act.setLoggedIn(loggedIn))
        },
        setGame: (game) => {
            dispatch(act.setGame(game))
        },
        setTeam: (team) => {
            dispatch(act.setTeam(team))
        },
        updateGameWith: (key, val) => {
            dispatch(act.setGameProperty(key, val))
        },
        updateState: (props) => {
            dispatch(act.setProperties(props))
        },
        show: (props) => {
            dispatch(act.setProperties(props))
        }
    }
}


const UploadGame = connect(mapStateToProps, mapDispatchToProps)(UploadGameComponent)
export default UploadGame

